// extracted by mini-css-extract-plugin
export default {"Order":"Order_Order__RlbBk","Header":"Order_Header__Pizbz"};